module.exports = __webpack_public_path__ + "static/media/core_switch.0c4be736.jpeg";